// MARK://dhk8/admin-shell/lib/clients/passkeys
// Optional WebAuthn passkey registration during /signup. NEVER blocks the flow: if the
// browser has no WebAuthn, or the user declines, we just move on.
// TODO(backend): `dhk8-platform-auth` may not expose `POST /v1/auth/passkeys/register-begin`
// /`register-complete` yet — when it doesn't, `registerPasskey()` returns { ok:false, reason:'not-supported' }
// (in preview it always simulates success so the UX can be exercised).
import { svcUrl, apiFetch } from '../api.js'
import { PREVIEW_STUB } from '../env.js'

export function webauthnSupported(): boolean {
  return typeof window !== 'undefined' && !!window.PublicKeyCredential && typeof navigator !== 'undefined' && !!navigator.credentials
}

export async function registerPasskey(email: string): Promise<{ ok: true } | { ok: false; reason: string }> {
  if (!webauthnSupported()) return { ok: false, reason: 'not-supported' }
  if (PREVIEW_STUB) return new Promise((r) => setTimeout(() => r({ ok: true }), 600))
  try {
    // begin → get PublicKeyCredentialCreationOptions; in a real impl we'd decode base64url
    // challenge/user.id, call navigator.credentials.create(), then post the attestation.
    const opts = await apiFetch<{ publicKey: PublicKeyCredentialCreationOptions }>(svcUrl('dhk8-platform-auth', '/v1/auth/passkeys/register-begin'), { method: 'POST', body: { email } })
    const cred = await navigator.credentials.create({ publicKey: opts.publicKey })
    if (!cred) return { ok: false, reason: 'declined' }
    await apiFetch<void>(svcUrl('dhk8-platform-auth', '/v1/auth/passkeys/register-complete'), { method: 'POST', body: { id: cred.id, type: cred.type } })
    return { ok: true }
  } catch (err) {
    // Endpoint missing (404) → treat as not-supported; user cancel → declined.
    const msg = err instanceof Error ? err.message : String(err)
    return { ok: false, reason: /404|not.?found/i.test(msg) ? 'not-supported' : 'declined' }
  }
}
